export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const DEFAULT_PAGE = 1;
export const KEY = `fd6604db-ec09-4eca-a189-d4565aef3c87`;
export const CLOSE_WINDOW = 1.5;
